import { KYC_DOC_TYPES } from "../../../config/const";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "react-bootstrap";

const KycList = ({ kycDocuments = [] }) => {
  const navigate = useNavigate();
  return (
    <div className="table-responsive my-4 kyc-table">
      <Table className=" text-white ">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Type</th>
            <th scope="col">Status</th>
            <th scope="col">Document Id</th>
            <th scope="col">Created At</th>
            {/* <th scope="col">Action</th> */}
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {(kycDocuments &&
            kycDocuments.map((item, index) => {
              return (
                <tr key={index}>
                  <th scope="row">{index + 1}</th>

                  <td>
                    {KYC_DOC_TYPES.find((f) => f.key === item?.type)?.name}
                  </td>
                  <td>{item?.status}</td>
                  <td>{item?.documentId}</td>
                  <td>
                    {dayjs(item?.createdAt).format("dddd DD MMM, hh:mm A")}
                  </td>
                  <td>
                    <Button onClick={() => navigate(`/kyc/${item?.type}`)}>
                      View
                    </Button>
                  </td>
                </tr>
              );
            })) ||
            null}
        </tbody>
      </Table>
    </div>
  );
};
export default KycList;
